<template>
  <div class="toast-alert fixed z-[5000] top-0 left-0 right-0 pt-2 sm:pt-12 px-3 flex flex-col justify-center items-center space-y-2 pointer-events-none">
    <ToastMessage
      v-for="message in messages"
      :key="message.id"
      :message="message"
    />
  </div>
</template>

<script lang="ts">
export default {
  name: 'toast'
}
</script>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useToastStore } from './store'
import ToastMessage from './toast-message.vue'
const { messages } = storeToRefs(useToastStore())
</script>
